import { element, string } from 'prop-types';
import './Detail.css';

const Detail = ({ children, icon, title, description = null }) => {
  return (
    <div className="detail pad-8 mar-h-16 c-black-60">
      <i className={`fal ${icon} fs-36`} />
      <h4 className="fs-18 fw-bold lh-lg c-black-60">{title}</h4>
      {description && <p className="fs-16 lh-lg c-black-60 mar-0 pad-0 desc">{description}</p>}
      {children}
    </div>
  );
};

Detail.propTypes = {
  children: element.isRequired,
  icon: string.isRequired,
  title: string.isRequired,
  description: string,
};

export default Detail;
